import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { Button, LinkTo } from '../../../helpers';

function OrganizationDelete({ item, onDelete }) {
  return (
    <div className="row">
      <div className="col-12">
        <div className="alert alert-danger">
          You are about to delete:&nbsp;
          <LinkTo href={`organizations/${item.id}/show`}>{get(item, 'attributes.name')}</LinkTo>.&nbsp;
          Are you sure?
        </div>

        <div className="btn-group">
          <LinkTo button icon="times-circle" color="secondary" href="organizations">
            Cancel
          </LinkTo>
          <Button button icon="trash" color="danger" href="organizations" onClick={() => onDelete(item)}>
            Yes, Delete
          </Button>
        </div>
      </div>
    </div>
  );
}

OrganizationDelete.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number
  }).isRequired,
  onDelete: PropTypes.func.isRequired
};

export default OrganizationDelete;
